import type { MigrationTaskProgressUpdate } from '@schema';
import {
  STATUS_ICON_CHECK_O,
  STATUS_ICON_LOADING,
  STATUS_ICON_TIMES_O,
  STATUS_ICON_CLOCK
} from '@/common/utils/statuses';

export interface MappedProgressUpdate {
  id: string;
  index: number;
  message: string;
  createdAt: string;
  /** Present for disk replication task progress (percent 0–100). */
  progress?: number | null;
}

export const formatTaskType = (taskType: string): string => {
  const normalized = taskType.replace(/_/g, ' ').toLowerCase();
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
};

export const taskStatusIcon = (status: string): string => {
  switch (status.toUpperCase()) {
    case 'COMPLETED': return STATUS_ICON_CHECK_O;
    case 'RUNNING':
    case 'STARTING':
    case 'PENDING': return STATUS_ICON_LOADING;
    case 'ERROR':
    case 'FAILED':
    case 'FAILED_TO_SCHEDULE':
    case 'FAILED_TO_CANCEL': return STATUS_ICON_TIMES_O;
    default: return STATUS_ICON_CLOCK;
  }
};

export const mapProgressUpdates = (updates: MigrationTaskProgressUpdate[] | undefined): MappedProgressUpdate[] => (updates ?? [])
  .slice()
  .sort((a, b) => (a.index ?? 0) - (b.index ?? 0))
  .map(p => ({
    id: p.id ?? '',
    index: p.index ?? 0,
    message: p.message ?? '',
    createdAt: p.created_at ?? '',
    progress: p.progress ?? null
  }));

export type { MigrationTaskProgressUpdate };
